import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';

import { Close_Large } from '@spaces-ui/meadow/icons/svgs';

@Component({
  selector: 'mdw-chip',
  templateUrl: './chip.html',
  styleUrls: ['./chip.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwButton],
})
export class MdwChip {
  public canDismiss = input(true);
  /** Accessible label for the dismiss button, e.g. 'Remove partyparrot'. */
  public dismissLabel = input<string>();
  public dismiss = output<MouseEvent>();

  public icons = { Close_Large };
}
